import { render, staticRenderFns } from "./QA_th.vue?vue&type=template&id=3925f28e&scoped=true&"
import script from "./QA_th.vue?vue&type=script&lang=js&"
export * from "./QA_th.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3925f28e",
  null
  
)

export default component.exports